import { PREFERENCE_IDENTIFIERS } from "../../util/constants"
import { updatePreferencesForQuickLinks } from "../data-sources/aws-lambda/preferences"
import { AWS_LAMBDA_SERVICE, PREFERENCES, getPreferences, updatePreferences } from "../data-sources/enums"
import { buildQuery } from "./buildQueries"
import { selectPreferences, setPreferences } from "./slices/preferences"


const _updatePrefMutation = buildQuery(AWS_LAMBDA_SERVICE, PREFERENCES, {
  queryType: "update", 
  gqlQueryType: "mutation", 
  variables: ['key', 'value', 'type'] 
} )


const overridenPreferenceMutation = {
  searchPage: async (parms = {}, options) => {
    const { query, type, remove } = parms
    let links = parms?.links ?? []
    const state = options.getState()
    const dispatch = options.dispatch
    const prefs = selectPreferences(state)

    let updatedState = { ...prefs }
    if((remove?.link || remove?.title) && !links?.length) {
      let updatedLinks = prefs[query] ?? [] 

      updatedLinks = updatedLinks.filter(o => {
        const match = o.link === remove.link || o.title === remove.tile
        return !match
      })
      links = updatedLinks
    }
    if(query) {
      updatedState[query] = links
    }
    
    dispatch(setPreferences({
      query,
      links
    }))
    
    const value = Object.entries(updatedState).map(([key, links]) => ({
      type: key,
      links
    }))

    return await _updatePrefMutation.queryFn({
      key: PREFERENCE_IDENTIFIERS.SEARCH,
      value: JSON.stringify(value),
      type: type ?? 'ARRAY'
    }, options)
    
  },
  setQuickLinks: async (parms = {}, options) => {
    const { links = [] } = parms ?? {}
    const { dispatch,getState } = options

    const res = await _updatePrefMutation.queryFn({
      key: PREFERENCE_IDENTIFIERS.QUICKLINKS,
      value: JSON.stringify(links),
      type: 'ARRAY'
    }, options)

    const updatedQuickLinks = res?.data?.[updatePreferences]?.quickLinks
    updatePreferencesForQuickLinks({
      dispatch,
      getState,
      data: updatedQuickLinks
    })

    // Update the getPreferences RTK Query cache so useQuickLinksWithPreferences
    // reads the freshly saved quicklinks instead of stale cached data
    const { graphqlApi } = await import("./api")
    dispatch(graphqlApi.util.updateQueryData('getPreferences', undefined, (draft) => {
      const prefs = draft?.[getPreferences]
      if(Array.isArray(prefs)) {
        const idx = prefs.findIndex(({ key }) => key?.startsWith(PREFERENCE_IDENTIFIERS.QUICKLINKS))
        if(idx >= 0) {
          prefs[idx].quickLinks = updatedQuickLinks ?? []
        } else {
          prefs.push({ key: PREFERENCE_IDENTIFIERS.QUICKLINKS, quickLinks: updatedQuickLinks ?? [] })
        }
      }
    }))

    return res
  }
}


export default overridenPreferenceMutation